import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router";
import Swal from "sweetalert2";
import DataTable from "../components/DataTable";
const moment = require("moment");

const ListarContratos = () => {
  const { id } = useParams();
  const [contratos, setContratos] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ==============================
  // Eliminar contrato
  // ==============================
  const deleteContrato = async (idContrato) => {
    try {
      const result = await Swal.fire({
        title: "¿Está seguro?",
        text: "¡No podrá revertir este proceso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        await axios.delete(`/api/contratos/delete/${idContrato}`);
        await getData();

        Swal.fire({
          icon: "success",
          title: "Contrato eliminado correctamente",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      Swal.fire("Error", "No se pudo eliminar el contrato", "error");
    }
  };

  // ==============================
  // Acciones del SELECT
  // ==============================
  const handleAccion = async (accion, contrato) => {
    if (!accion) return;

    switch (accion) {
      case "agendas":
        navigate(`/instructor/agendas/${contrato._id}`, { state: { contrato } });
        break;

      case "listar_informes":
        navigate(`/instructor/informecontractual/listar/${contrato._id}`);
        break;

      case "informe":
        navigate(`/instructor/informecontractual/${contrato._id}`);
        break;

      case "obligaciones":
        navigate(`/instructor/obligaciones/${contrato._id}`);
        break;

      case "editar":
        navigate(`/instructor/registrarcontratos/editar/${contrato._id}`, {
          state: { contrato },
        });
        break;

      case "eliminar":
        await deleteContrato(contrato._id);
        break;

      default:
        break;
    }
  };

  // ==============================
  // Obtener datos
  // ==============================
  const getData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/api/contratos/listbyinstructor/${id}`);

      if (res.data.ok) {
        const dataConItem = (res.data.contratos || []).map((contrato, index) => ({
          item: index + 1,
          _id: contrato._id,
          numeroContrato: contrato.contrato,

          fechaInicio: contrato.fechaInicio
            ? moment.utc(contrato.fechaInicio).add(5, "hours").format("DD/MM/YYYY")
            : "-",

          fechaFin: contrato.fechaFin
            ? moment.utc(contrato.fechaFin).add(5, "hours").format("DD/MM/YYYY")
            : "-",

          valorContrato: `$${Number(contrato.valorContrato || 0).toLocaleString("es-CO")}`,
          estado: contrato.estado || "-",
          entidadContratante: contrato.regional?.nombreRegional || "-",
          centroFormacion: contrato.centroFormacion?.nombreCentro || "-",

          // ============================================
          // 🔹 SISTEMA ACTUAL: SELECT DE ACCIONES
          // ============================================
          funciones: (
            <div className="d-flex justify-content-end">
              <div className="input-group input-group-sm" style={{ width: 240 }}>
                <span className="input-group-text bg-white">
                  <i className="fa-solid fa-gear"></i>
                </span>

                <select
                  className="form-select"
                  defaultValue=""
                  onChange={(e) => {
                    const accion = e.target.value;
                    e.target.value = "";
                    handleAccion(accion, contrato);
                  }}
                >
                  <option value="" disabled>
                    Acciones del contrato…
                  </option>

                  <optgroup label="Gestión">
                    <option value="agendas">✈️ Agendas de Viaje</option>
                    <option value="listar_informes">📋 Listar Informes</option>
                    <option value="informe">📝 Registrar Informe</option>
                    <option value="obligaciones">📑 Obligaciones</option>
                  </optgroup>

                  <optgroup label="Administración">
                    <option value="editar">✏️ Editar Contrato</option>
                    <option value="eliminar">🗑️ Eliminar Contrato</option>
                  </optgroup>
                </select>
              </div>
            </div>
          ),

          // ============================================
          // 🔸 SISTEMA ANTERIOR: BOTONES (COMENTADOS)
          // Solo descomenta si quieres volver a botones
          // ============================================

          /*
          funciones: (
            <div className="d-flex gap-2 flex-wrap justify-content-end">

              <button
                className="btn btn-dark btn-sm"
                style={{ width: 34, height: 34 }}
                onClick={() =>
                  navigate(`/instructor/agendas/${contrato._id}`, {
                    state: { contrato },
                  })
                }
                title="Agendas"
              >
                <i className="fa-solid fa-plane"></i>
              </button>

              <button
                className="btn btn-outline-dark btn-sm"
                style={{ width: 34, height: 34 }}
                onClick={() =>
                  navigate(`/instructor/informecontractual/listar/${contrato._id}`)
                }
                title="Listar Informes"
              >
                <i className="fa-solid fa-list-check"></i>
              </button>

              <button
                className="btn btn-dark btn-sm"
                style={{ width: 34, height: 34 }}
                onClick={() =>
                  navigate(`/instructor/informecontractual/${contrato._id}`)
                }
                title="Informe"
              >
                <i className="fa-solid fa-clipboard-check"></i>
              </button>

              <button
                className="btn btn-outline-secondary btn-sm"
                style={{ width: 34, height: 34 }}
                onClick={() =>
                  navigate(`/instructor/obligaciones/${contrato._id}`)
                }
                title="Obligaciones"
              >
                <i className="fa-solid fa-clipboard-list"></i>
              </button>

              <button
                className="btn btn-warning btn-sm"
                style={{ width: 34, height: 34 }}
                onClick={() =>
                  navigate(`/instructor/registrarcontratos/editar/${contrato._id}`, {
                    state: { contrato },
                  })
                }
                title="Editar"
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </button>

              <button
                className="btn btn-danger btn-sm"
                style={{ width: 34, height: 34 }}
                onClick={() => deleteContrato(contrato._id)}
                title="Eliminar"
              >
                <i className="fa-solid fa-trash"></i>
              </button>

            </div>
          ),
          */
        }));

        setContratos(dataConItem);
      } else {
        setContratos([]);
      }
    } catch (error) {
      console.error("Error al obtener contratos:", error);
      setContratos([]);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const columns = useMemo(
    () => [
      { Header: "Item", accessor: "item" },
      { Header: "N° Contrato", accessor: "numeroContrato" },
      { Header: "Inicio", accessor: "fechaInicio" },
      { Header: "Fin", accessor: "fechaFin" },
      { Header: "Valor ($)", accessor: "valorContrato" },
      { Header: "Estado", accessor: "estado" },
      { Header: "Entidad", accessor: "entidadContratante" },
      { Header: "Centro", accessor: "centroFormacion" },
      { Header: "Acciones", accessor: "funciones" },
    ],
    []
  );

  return (
    <div className="container-fluid px-3 py-3">
      <div className="bg-white border rounded-4 shadow-sm overflow-hidden">
        <div className="px-4 py-3 border-bottom">
          <h5 className="fw-semibold mb-1">Contratos del Instructor</h5>
          <small className="text-secondary">
            Gestión contractual, informes y obligaciones asociadas.
          </small>
        </div>

        <div>
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border" role="status" />
              <div className="mt-3">Cargando contratos…</div>
            </div>
          ) : contratos.length > 0 ? (
            <DataTable columns={columns} data={contratos} />
          ) : (
            <div className="text-center py-5 text-secondary">
              No hay contratos registrados.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListarContratos;